module.exports = __webpack_public_path__ + "img/agreement-people.21bdd172.svg";